"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9957,2074],{

/***/ 37839:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ Maps_AuctionListMap; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../core/src/components/Maps/index.tsx + 12 modules
var Maps = __webpack_require__(64836);
// EXTERNAL MODULE: ../../node_modules/react-leaflet/esm/FeatureGroup.js
var FeatureGroup = __webpack_require__(42748);
// EXTERNAL MODULE: ../core/src/components/Maps/Layers/LayerGeoJSON.tsx
var LayerGeoJSON = __webpack_require__(33724);
// EXTERNAL MODULE: ../../node_modules/next-i18next/dist/esm/index.js + 11 modules
var esm = __webpack_require__(33052);
// EXTERNAL MODULE: ../../node_modules/next/router.js
var next_router = __webpack_require__(5632);
// EXTERNAL MODULE: ../../node_modules/tailwind-styled-components/dist/index.js
var dist = __webpack_require__(17471);
var dist_default = /*#__PURE__*/__webpack_require__.n(dist);
// EXTERNAL MODULE: ../graphql/src/generated/index.ts + 11 modules
var generated = __webpack_require__(63575);
// EXTERNAL MODULE: ../core/src/components/Button.tsx
var Button = __webpack_require__(36573);
// EXTERNAL MODULE: ../core/src/components/Maps/Popups/LayerPopup.tsx
var LayerPopup = __webpack_require__(44638);
// EXTERNAL MODULE: ../core/src/utils/index.ts
var utils = __webpack_require__(75920);
// EXTERNAL MODULE: ../core/src/utils/cartography.ts
var cartography = __webpack_require__(19371);
;// CONCATENATED MODULE: ../core/src/components/Maps/Popups/AuctionPopup.tsx









function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "flex justify-between gap-4"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "text-xl font-medium my-2"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
var Line = dist_default().div(_templateObject());
var Title = dist_default().div(_templateObject1());
var AuctionPopup = function(param1) {
    var position = param1.position, cadastralPlotId = param1.cadastralPlotId, auctionId = param1.auctionId;
    var ref, ref1, ref2;
    var t = (0,esm/* useTranslation */.$G)([
        'forest',
        'common',
        'auctions'
    ]).t;
    var router = (0,next_router.useRouter)();
    var data = (0,generated/* usePopupCadastralPlotQuery */.PBk)({
        variables: {
            id: cadastralPlotId
        }
    }).data;
    var popupCadastralPlot = data === null || data === void 0 ? void 0 : data.cadastralPlot;
    var auction = popupCadastralPlot === null || popupCadastralPlot === void 0 ? void 0 : (ref = popupCadastralPlot.auctions) === null || ref === void 0 ? void 0 : ref.find(function(param) {
        var id = param.id;
        return id === auctionId;
    });
    var center = (0,cartography/* getCadastralPlotCenter */.n5)(popupCadastralPlot);
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(LayerPopup/* LayerPopup */.K, {
        position: position,
        layer: "cadastralPlots",
        title: t('common:map.cadastralPlot'),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Title, {
                children: auction === null || auction === void 0 ? void 0 : auction.title
            }),
            popupCadastralPlot ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Line, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(LayerPopup/* LayerPopup.Item */.K.Item, {
                                label: t('common:startingPrice'),
                                value: (0,utils/* formatMoney */.lb)(auction === null || auction === void 0 ? void 0 : auction.startingBid)
                            }),
                            (auction === null || auction === void 0 ? void 0 : (ref1 = auction.highestBidObject) === null || ref1 === void 0 ? void 0 : ref1.price) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(LayerPopup/* LayerPopup.Item */.K.Item, {
                                label: t('common:highestBid'),
                                value: (0,utils/* formatMoney */.lb)(auction === null || auction === void 0 ? void 0 : (ref2 = auction.highestBidObject) === null || ref2 === void 0 ? void 0 : ref2.price)
                            }) : null
                        ]
                    }),
                    center ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex justify-start",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            className: "text-primary-500 text-base mb-2 hover:underline",
                            href: (0,cartography/* googleDirectionsURL */.lL)(center),
                            target: "_blank",
                            rel: "noreferrer",
                            children: t('common:navigateTo')
                        })
                    }) : null,
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                        title: t('auctions:showMore'),
                        value: "cadastral-plot-popup-more",
                        onClick: function() {
                            return router.push("/auctions/".concat(auctionId));
                        }
                    })
                ]
            }) : null
        ]
    }));
};

;// CONCATENATED MODULE: ../core/src/components/Maps/Layers/CadastralPlotsGroup.tsx





function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
var CadastralPlotsGroup = /*#__PURE__*/ (0,react.memo)(function(param1) {
    var _geoJSON = _slicedToArray(param1.geoJSON, 2), _ = _geoJSON[0], geoJSON = _geoJSON[1], eventHandlers = param1.eventHandlers, pathOptions = param1.pathOptions, auction = param1.auction, id = param1.id;
    var ref = (0,react.useState)(null), popupPosition = ref[0], setPopupPosition = ref[1];
    var featureGroupEventHandlers = (0,react.useMemo)(function() {
        return _objectSpread({}, eventHandlers, {
            click: function(param) {
                var latlng = param.latlng;
                return setPopupPosition([
                    latlng.lat,
                    latlng.lng
                ]);
            }
        });
    }, [
        eventHandlers
    ]);
    var geoJSONFeatures = (0,react.useMemo)(function() {
        return geoJSON.map(function(geometry) {
            return {
                geometry: geometry,
                properties: auction,
                type: 'Feature'
            };
        });
    }, [
        auction,
        geoJSON
    ]);
    return geoJSONFeatures.length ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FeatureGroup/* FeatureGroup */.$, {
                eventHandlers: featureGroupEventHandlers,
                pathOptions: pathOptions,
                children: geoJSONFeatures.map(function(data, index) {
                    /*#__PURE__*/ return (0,jsx_runtime.jsx)(LayerGeoJSON/* LayerGeoJSON */.B, {
                        color: "secondary",
                        data: data
                    }, index);
                })
            }),
            popupPosition ? /*#__PURE__*/ (0,jsx_runtime.jsx)(AuctionPopup, {
                position: popupPosition,
                cadastralPlotId: id,
                auctionId: auction.id
            }) : null
        ]
    }) : null;
});

// EXTERNAL MODULE: ../core/src/components/Maps/Layers/DeflateLayer.tsx
var DeflateLayer = __webpack_require__(52889);
// EXTERNAL MODULE: ../core/src/components/Maps/FitMap.tsx
var FitMap = __webpack_require__(87593);
// EXTERNAL MODULE: ../core/src/contexts/AuctionList.tsx
var AuctionList = __webpack_require__(90755);
// EXTERNAL MODULE: ../core/src/contexts/Layers.tsx
var Layers = __webpack_require__(95106);
// EXTERNAL MODULE: ../core/src/config/domains.js
var domains = __webpack_require__(2811);
var domains_default = /*#__PURE__*/__webpack_require__.n(domains);
// EXTERNAL MODULE: ../core/src/components/Maps/Controls/LayersControl/index.tsx + 10 modules
var LayersControl = __webpack_require__(48151);
// EXTERNAL MODULE: ../core/src/components/Maps/Layers/TaxonomicPlotsIntersectionLayer.tsx + 1 modules
var TaxonomicPlotsIntersectionLayer = __webpack_require__(63025);
;// CONCATENATED MODULE: ../core/src/components/Maps/AuctionListMap.tsx













function AuctionListMap_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function AuctionListMap_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function AuctionListMap_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function AuctionListMap_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function AuctionListMap_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function AuctionListMap_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            AuctionListMap_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function AuctionListMap_slicedToArray(arr, i) {
    return AuctionListMap_arrayWithHoles(arr) || AuctionListMap_iterableToArrayLimit(arr, i) || AuctionListMap_unsupportedIterableToArray(arr, i) || AuctionListMap_nonIterableRest();
}
function AuctionListMap_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return AuctionListMap_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return AuctionListMap_arrayLikeToArray(o, minLen);
}
var AuctionGroup = function(param1) {
    var cadastralPlots = param1.cadastralPlots, auction = param1.auction;
    var ref = (0,react.useContext)(AuctionList/* default */.Z), selected = ref.selected, setSelected = ref.setSelected;
    var pathOptions = (0,react.useMemo)(function() {
        return {
            fillOpacity: 0,
            weight: selected === auction.id ? 6 : 4
        };
    }, [
        selected,
        auction
    ]);
    var eventHandlers = (0,react.useMemo)(function() {
        return {
            mouseover: function() {
                return setSelected(auction.id);
            },
            mouseout: function() {
                return setSelected(null);
            }
        };
    }, [
        auction,
        setSelected
    ]);
    var cadastralPlotsWithGeoJSONData = cadastralPlots.filter(function(param) {
        var _geoJSON = AuctionListMap_slicedToArray(param.geoJSON, 2), bounds = _geoJSON[0], geoJSON = _geoJSON[1];
        return bounds && geoJSON.length;
    });
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: cadastralPlotsWithGeoJSONData.map(function(cadastralPlot) {
            /*#__PURE__*/ return (0,jsx_runtime.jsx)(CadastralPlotsGroup, AuctionListMap_objectSpread({}, cadastralPlot, {
                auction: auction,
                pathOptions: pathOptions,
                eventHandlers: eventHandlers
            }), cadastralPlot.id);
        })
    }));
};
var mapProps = {
    zoom: 6,
    center: (domains_default()).current.mapCoordinates
};
var AuctionListMap = function(param2) {
    var _auctions = param2.auctions, auctions = _auctions === void 0 ? [] : _auctions, disableFallback = param2.disableFallback;
    var _ref = (0,react.useMemo)(function() {
        var cadastralPlots2 = auctions.flatMap(function(param) {
            var cadastralPlots = param.cadastralPlots;
            return cadastralPlots;
        });
        var ref = AuctionListMap_slicedToArray((0,cartography/* cadastralPlotsToGeoJSONData */.gP)(cadastralPlots2), 1), bounds = ref[0];
        return [
            bounds,
            auctions.map(function(_param) {
                var cadastralPlots = _param.cadastralPlots, auction = _objectWithoutProperties(_param, [
                    "cadastralPlots"
                ]);
                return {
                    auction: auction,
                    cadastralPlots: cadastralPlots.map(function(cadastralPlot) {
                        return AuctionListMap_objectSpread({}, cadastralPlot, {
                            geoJSON: (0,cartography/* cadastralPlotsToGeoJSONData */.gP)([
                                cadastralPlot
                            ])
                        });
                    })
                };
            }), 
        ];
    }, [
        auctions
    ]), mapBounds = _ref[0], polygons = _ref[1];
    var deflateLayerKey = (0,react.useMemo)(function() {
        return auctions.map(function(param) {
            var id = param.id;
            return id;
        }).join('/');
    }, [
        auctions
    ]);
    var cadastralPlots1 = (0,react.useMemo)(function() {
        return (0,utils/* removeDuplicateObjects */.md)(auctions.flatMap(function(param) {
            var cadastralPlots = param.cadastralPlots;
            return cadastralPlots;
        }));
    }, [
        auctions
    ]);
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(Layers/* LayersContextProvider */.o, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Maps["default"], AuctionListMap_objectSpread({}, mapProps, {
            fallback: !disableFallback && !!auctions.length && !mapBounds,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(LayersControl/* LayersControl */.e, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(FitMap/* FitMap */.R, {
                    bounds: mapBounds
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(DeflateLayer/* DeflateLayer */.O, {
                    children: polygons.map(function(param) {
                        var auction = param.auction, cadastralPlots = param.cadastralPlots;
                        /*#__PURE__*/ return (0,jsx_runtime.jsx)(AuctionGroup, {
                            auction: auction,
                            cadastralPlots: cadastralPlots
                        }, auction.id);
                    })
                }, deflateLayerKey),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(TaxonomicPlotsIntersectionLayer/* TaxonomicPlotIntersectionLayer */.B, {
                    cadastralPlots: cadastralPlots1,
                    labelsVisible: true
                })
            ]
        }))
    }));
};
/* harmony default export */ var Maps_AuctionListMap = (/*#__PURE__*/(0,react.memo)(AuctionListMap));


/***/ })

}]);